import { type ReactNode } from 'react';
import { type Event } from '@goodneighbor/api/schemas/events/event.schema';
import { formatEventDate, formatEventTime } from '@/services/dateTime';
import { isExternalEvent } from './event';
import styles from '../eventSlideOut.module.scss';

export type EventMetaSection = {
  title: string;
  content: ReactNode;
};

export function getEventMetaSections(event: Event): EventMetaSection[] {
  const sections: EventMetaSection[] = [
    {
      title: 'Event location',
      content: (
        <>
          {event.locationName}
          {event.address && (
            <>
              <br />
              {event.address}
            </>
          )}
          {(event.city || event.region || event.postalCode) && (
            <>
              <br />
              {[event.city, event.region].filter(Boolean).join(', ')}
              {event.postalCode ? ` ${event.postalCode}` : ''}
            </>
          )}
        </>
      )
    },
    {
      title: 'Date and time',
      content: (
        <>
          {event.startsAt
            ? formatEventDate(event.startsAt, event.timeZoneId)
            : ''}
          <br />
          {event.startsAt
            ? formatEventTime(event.startsAt, event.timeZoneId)
            : ''}
          {event.endsAt ? (
            <>
              {' '}
              -{' '}
              {formatEventTime(event.endsAt, event.timeZoneId, {
                timeZoneName: 'short'
              })}
            </>
          ) : null}
        </>
      )
    }
  ];

  if (isExternalEvent(event) && event.sourceUrl) {
    sections.push({
      title: 'Registration platform',
      content: (
        <a
          className={styles.eventMetaLink}
          href={event.sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {new URL(event.sourceUrl).hostname.replace(/^www\./, '')}
        </a>
      )
    });
  } else if (!isExternalEvent(event) && event.website) {
    sections.push({
      title: 'Website',
      content: (
        <a
          className={styles.eventMetaLink}
          href={event.website}
          target="_blank"
          rel="noreferrer"
        >
          {event.website}
        </a>
      )
    });
  }

  return sections;
}
